import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';

const MapControlSelection = ({ title, id, value, onChange, options }) => {
  return (
    <FormControl variant="filled" className={`mapControlSelection`}>
      <InputLabel htmlFor={id}>{title}</InputLabel>
      <Select native
        value={value}
        onChange={onChange}
        className="mapControlSelect"
        input={
          <Input name={id} id={id} />
        }
        disableUnderline>
        {options.map((item, index) => <option key={index} value={item.value} disabled={item.disabled}>{item.label}</option>)}
      </Select>
    </FormControl>
  )
}

export default MapControlSelection;